import { createResource } from 'redux-rest-resource'
import { remove, includes, map, get, cloneDeep } from 'lodash'
import { baseURL } from './'

export const { types, actions, rootReducer } = createResource({
  name: 'basin',
  url: `${baseURL}`,
  credentials: 'include',
  actions: {
    fetch: { method: 'GET', gerundName: 'fetching', url: './basins' },
    get: { method: 'GET', gerundName: 'getting', url: './basins/:id' },
    update: {
      method: 'PUT',
      gerundName: 'updating',
      url: './basins/:id',
      assignResponse: true,
      reduce: ({ items, item, ...state }, { context, body, status }) => {
        const isUpdating = status === 'pending'

        // DonnÃ©es Ã  stocker dans le reducer
        // Lors de la mise Ã  jour stocker les donnÃ©es sources
        // Sinon stocker les donnÃ©es reÃ§ues par le serveur
        const updated = isUpdating ? context : body

        // Mise Ã  jour de l'Ã©lÃ©ment
        const updatedItem =
          get(updated, 'id') === get(item, 'id')
            ? isUpdating
              ? { ...item, ...updated }
              : updated
            : item

        // Mise Ã  jour de la liste de tous les Ã©lÃ©ments avec l'Ã©lÃ©ment Ã  jour
        const updatedItems = map(items, item =>
          get(updated, 'id') === get(item, 'id') ? updatedItem : item
        )

        return { ...state, items: updatedItems, item: updatedItem, isUpdating }
      }
    },
    create: { method: 'POST', gerundName: 'creating', url: './basins' },
    archive: {
      method: 'PATCH',
      gerundName: 'archiving',
      url: './basins/:id/archive',
      reduce: ({ items, ...state }, { body: archived }) => {
        // Suppression des donnÃ©es archivÃ©es du store
        remove(items, { id: get(archived, 'id') })

        return { ...state, items: cloneDeep(items) }
      }
    },
    archiveMany: {
      isArray: true,
      alias: 'archive',
      method: 'PATCH',
      gerundName: 'archiving',
      url: './basins/archive',
      reduce: ({ items, ...state }, { body: archived }) => {
        // Suppression des donnÃ©es archivÃ©es du store
        remove(items, ({ id }) => includes(map(archived, 'id'), id))

        return { ...state, items: cloneDeep(items) }
      }
    },
    delete: { method: 'DELETE', gerundName: 'deleting', url: './basins/:id' },
    deleteMany: {
      isArray: true,
      alias: 'delete',
      method: 'DELETE',
      gerundName: 'deleting',
      url: './basins/delete'
    }
  }
})
